export default class InvoiceDoc {
  id?: number | null;
  documentType?: string | null;
  number?: number | null;
  fileDate?: string | Date | null;   // string for JSON dates, Date for parsed objects
  invoiceNumber?: number | null;
  fileSize?: number | null;
  source?: string | null;
  s3Key?: string | null;
  hasBlob?: boolean | null;
  archivedDate?: string | Date | null;
  archivedBy?: string | null;
  archiveReason?: string | null;
  archiveAction?: number | null;
}



// WEBPACK FOOTER //
// ./src/components/project-billing/models/InvoiceDoc.ts